import { create } from 'zustand';

interface PromptLibraryModalState {
	isOpen: boolean;
	open: () => void;
	close: () => void;
}

/**
 * Open-state for the prompt-library modal, deliberately kept OUT of
 * BizySidePanelChatView's render tree.
 *
 * That component is ~1,900 lines and re-renders for ~170ms. When the modal's
 * open flag lived in a `useDisclosure()` called by a hook inside it, every
 * open/close re-rendered the whole thing. Holding the flag in this store — read
 * only by the modal host, never by the chat view — means toggling it re-renders
 * only the modal, not the chat view. Actions are stable, so selecting just
 * `open`/`close` (without `isOpen`) subscribes a consumer to nothing.
 */
export const usePromptLibraryModalStore = create<PromptLibraryModalState>((set) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
}));
